/**
 * Validates if a value is undefined
 * @param {*} v
 * @returns {Boolean}
 */
export const isUndef = v => typeof v === 'undefined' || v === null;

/**
 * Validates if a value is defined
 * @param {*} v
 * @returns {Boolean}
 */
export const isDef = v => typeof v !== 'undefined' && v !== null;

/**
 * Converts a value to a string if it's a number; returns the value unchanged if it's already a string.
 * @param {number|string} value
 * @returns {string}
 */
export const convertToString = value => {
  if (typeof value === 'number') {
    return value.toString();
  }
  if (typeof value === 'string') {
    return value;
  }

  throw new Error('Value must be a number or string');
};

/**
 * Validates if a string is empty after converting the value to a string.
 * @param {string|number} v
 * @returns {Boolean}
 */
export const isStringEmpty = v => {
  const strValue = convertToString(v);
  return strValue.length === 0 || !strValue.trim();
};

/**
 * Validates if is a string is a valid number
 * @param {string} v
 * @returns {Boolean}
 */
export const isValidValue = v => v && !Number.isNaN(v);

/**
 * Validates manual price field
 * @param {string} manualPrice
 * @param {string} floor
 * @param {string} ceiling
 * @returns {Boolean}
 * True if errors present (fails checks)
 * False if no errors with input/validation
 */
export const isManualPriceError = (manualPrice, floor, ceiling) => {
  // if manual price is type null validation is canceled
  if (manualPrice === null || manualPrice === '') return false;
  // if floor is present but ceiling is not included
  // manualPrice must be less than floor
  if (!isStringEmpty(floor) && isStringEmpty(ceiling)) {
    return Number(manualPrice) < Number(floor);
  }

  // if both floor and ceiling are included
  // manualPrice must be between floor and ceiling (not-inclusive)
  if (!isStringEmpty(floor) && !isStringEmpty(ceiling)) {
    return Number(manualPrice) < Number(floor) || Number(manualPrice) > Number(ceiling);
  }

  return false;
};
